import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import GroupingInscription from './GroupingInscription';
import GroupingConnexion from './GroupingConnexion';
import GroupingAuth from './GroupnigAuth';
import GroupingForgotPassword from './GroupingForgotPassword';
import { auth, provider } from './firebaseConfig';
import { signInWithPopup } from 'firebase/auth';
import useUserSession from './useUserSession';
import { saveSession } from './sessionManager';
import { useTranslation } from 'react-i18next';

function SectionConnexion({ googleCon, setGoogleCon, show, onHide }) {
  const [isConnexionVisible, setIsConnexionVisible] = useState(true);
  const [isInscriptionVisible, setIsInscriptionVisible] = useState(false);
  const [isAuthVisible, setIsAuthVisible] = useState(false);
  const [isForgotPasswordVisible, setIsForgotPasswordVisible] = useState(false);
  const [googleError, setGoogleError] = useState('');

  const { setUser } = useUserSession();
  const { t } = useTranslation();

  const handleConnexionClick = () => {
    setIsConnexionVisible(false);
    setIsInscriptionVisible(true);
  };

  const handleConnectWithGoole = async () => {
    try {
      const data = await signInWithPopup(auth, provider);
      //setGoogleCon(data.user.email);

      // Connexion à l'API /user
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/user/signinwithgoogle`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          password: data.user.uid,
          email: data.user.email,
          name: data.user.displayName,
          photo: data.user.photoURL
        }),
      });

      if (response.ok) {
        const responseData = await response.json();
        const token = responseData.token.replace('Bearer ', '');
        saveSession({ uid: responseData.user._id, email: responseData.user.email, name: responseData.user.name, token, state: responseData.status, photoURL: data.user.photoURL });
        setUser({ uid: responseData.user._id, state: responseData.status, email: responseData.user.email, name: responseData.user.name, photoURL: data.user.photoURL, token });
        onHide();
      } else {
        setGoogleError(t('auth.authFailed'));
      }
    } catch (error) {
      if (error?.code === 'auth/popup-closed-by-user' || error?.code === 'auth/cancelled-popup-request') return;
      setGoogleError(t('auth.networkError'));
    }
  };

  const handleInscriptionClick = () => {
    setIsConnexionVisible(true);
    setIsInscriptionVisible(false);
  };

  const handleAuthClick = () => {
    setIsAuthVisible(true);
    setIsConnexionVisible(false);
    setIsInscriptionVisible(false);
    setIsForgotPasswordVisible(false);
  };

  const handleForgotPasswordClick = () => {
    setIsForgotPasswordVisible(true);
    setIsConnexionVisible(false);
    setIsInscriptionVisible(false);
    setIsAuthVisible(false);
  };

  const handleBackToConnexion = () => {
    setIsConnexionVisible(true);
    setIsForgotPasswordVisible(false);
  };

  return (
    <Modal className="ModalConnexion" show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <div className="modal-title-left">
            {isConnexionVisible && (
              <>
                <span>{t('auth.connectOrCreate')}</span>
                <span>{t('auth.orCreateAccount')}</span>
              </>
            )}
            {isInscriptionVisible && (
              <>
                <span>{t('auth.createYourAccount')}</span>
                <span className="modal-title-left-sub">
                  {t('auth.enterRealInfo')}
                </span>
              </>
            )}
            {isForgotPasswordVisible && (
              <>
                <span>{t('auth.forgotPasswordTitle')}</span>
              </>
            )}
            {isAuthVisible && <span>{t('auth.authentication')}</span>}
          </div>
          <FontAwesomeIcon icon={faXmark} onClick={onHide} />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {isAuthVisible ? (
          <GroupingAuth />
        ) : (
          <>
            {isConnexionVisible && <GroupingConnexion handleClick={handleConnexionClick} handleConnectWithGoole={handleConnectWithGoole} handleForgotPassword={handleForgotPasswordClick} onLoginSuccess={onHide} googleError={googleError} setGoogleError={setGoogleError} />}
            {isInscriptionVisible && <GroupingInscription handleAuth={handleAuthClick} handleClick={handleInscriptionClick} handleConnectWithGoole={handleConnectWithGoole} googleError={googleError} setGoogleError={setGoogleError} />}
            {isForgotPasswordVisible && <GroupingForgotPassword handleClick={handleBackToConnexion} />}
          </>
        )}
      </Modal.Body>
    </Modal>
  );
}

export default SectionConnexion;